import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import {
	fetchInvoices,
	deleteInvoice,
} from '../../../../../Redux/Actions/Admin/ManageInvoiceActions';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import InvoiceForm from './InvoiceForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { InvoicesLoader } from './InvoicesLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import ReceiptPDF from '../../../../Shared/ReceiptPDF';
import Modal from 'react-modal';

class ManageInvoices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            invoiceInEdit: {},
            isPopupVisible: false,
            invoices: { data: [], total: 0 },
            modalVisible: false,
            selectedInvoice: {},
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: []
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {
        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (invoicesFetched) => {
        this.setState({
            ...this.state,
            invoices: invoicesFetched,
            isLoading: false
        });

        if (invoicesFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (invoicesFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            invoiceInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                if (element["field"] == "OrderDate") {
                    let date = element.value;
                    if (!date) {
                        date = "0001/01/01";
                    }
                    else {
                        date = (date + '').split(" ");
                        let day = date[2] + '';
                        let year = date[3] + '';
                        let month = "01";
                        switch (date[1]) {
                            case "Jan":
                                month = "01";
                                break;
                            case "Feb":
                                month = "02";
                                break;
                            case "Mar":
                                month = "03";
                                break;
                            case "Apr":
                                month = "04";
                                break;
                            case "May":
                                month = "05";
                                break;
                            case "Jun":
                                month = "06";
                                break;
                            case "Jul":
                                month = "07";
                                break;
                            case "Aug":
                                month = "08";
                                break;
                            case "Sep":
                                month = "09";
                                break;
                            case "Oct":
                                month = "10";
                                break;
                            case "Nov":
                                month = "11";
                                break;
                            case "Dec":
                                month = "12";
                                break;
                        }
                        date = year + "/" + month + "/" + day;
                        element["value"] = date;
                    }
                }
                else {
                    for (var key in t[i]) {
                        element[key] = element[key] + '';
                    }
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        var a = document.getElementById("excel-ref");
        a.href = ROOT_API_URL + "/StripePayment/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery);
        a.click();
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageInvoices/DeleteInvoice`, dataItem)
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the invoice.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            invoiceInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/StripePayment/SaveInvoice`, model)
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the invoice.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    showPDF = (data) => {
        this.setState({
            selectedInvoice: data,
            modalVisible: true
        });
    }

    cancel = () => {
        this.setState({
            modalVisible: false
        });
    }

    render() {
        return (
            <div id={"invoices-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading invoices" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.invoices.total}
                                {...this.state.dataState}
                                {...this.state.invoices}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <a id="excel-ref" href={ROOT_API_URL + "/StripePayment/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column field="InvoiceId" title="Invoice ID" />
                                <Column field="FirstName" title="First Name" />
                                <Column field="LastName" title="Last Name" />
                                <Column field="Description" title="Description" />
                                <Column field="AmountDue" title="Amount Due" filter="numeric" cell={(props) => (
                                        <td>
                                            ${props.dataItem.AmountDue}
                                        </td>
                                    )}
                                />
                                <Column field="CreateDate" title="Date" filter="date" cell={(props) => (
                                        <td>
                                            {props.dataItem.CreateDate.substring(0, 10)}
                                        </td>

                                    )}
                                />
                                <Column
                                    title="PDF Link"
                                    filterable={false}
                                    cell={(props) => (
                                        <td>
                                            <button onClick={() => this.showPDF(props.dataItem)}>Download</button>
                                        </td>
                                    )}
                                />
                                <Column field="IsActive" title="Active Invoice" filter="boolean"/>
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <InvoicesLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <InvoiceForm
                                dataItem={this.state.colorInEdit}
                                save={this.save}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>

                <div className="receipt">
                    <Modal
                        isOpen={this.state.modalVisible}
                        onRequestClose={this.cancel}
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                minWidth: '50vw',
                                maxWidth: '50vw',
                                minHeight: '80vh',
                                maxHeight: '80vh',
                                overflow: 'auto',
                                transform: 'translate(-50%, -50%)',
                                borderRadius: '5px'
                            }
                        }}
                    >
                        <ReceiptPDF pdfData={this.state.selectedInvoice} cancel={this.cancel}/>
                    </Modal>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		invoice: state.invoice,
		common: state.common
	};
}

export default connect(mapStateToProps, {
	fetchInvoices,
})(ManageInvoices);



